import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';

import Card from '../components/cards/Card';
import SInput from '../components/form/SInput';
import PDFDialog from '../components/modals/PDFDialog';
import usePdfDialogHook from '../../redux/hooks/usePdfDialogHook';
import PrintCardsContainer from '../components/cards/PrintCardsContainer';
import PageHeader from '../components/page/PageHeader';
import useUrlParams from '../hooks/useUrlParams';
import { QTYButtons } from '../components/form/QtyPrintComponent';

// http://localhost:3000/fnsku-product-label?sku=sku&fnsku=fnsku&expiration=2022-12-31&printQty=2&name=name&image=https://i5.walmartimages.com/seo/Greenies-Grain-Free-Dental-Treats-for-Dogs-36-oz-Pouch_65477239-ad0a-46a4-af60-912d6ac0f42d.3a08527277d6a083c09526312ebdddad.jpeg
// http://localhost:3000/fnsku-product-label?sku=sku&fnsku=fnsku&expiration=2022-12-31&printQty=2&name=name&image=https://i5.walmartimages.com/seo/Greenies-Grain-Free-Dental-Treats-for-Dogs-36-oz-Pouch_65477239-ad0a-46a4-af60-912d6ac0f42d.3a08527277d6a083c09526312ebdddad.jpeg&batchID=12312&asin=asinGoesHere

function FnSkuLabelPage() {
  const { canGenerate, isPDFDialogOpen, setIsPDFDialogOpen, pdfBase64, print } = usePdfDialogHook();

  const {
    resetAll,

    productFNSku,
    productName,
    productSku,
    productImage,
    productCondition,
    printQty,
    productExpiration,
    batchID,

    setProductSku,
    setProductFNSku,
    setPrintQty,
    setProductExpiration
  } = useUrlParams();

  const printWarningLabel3x2 = async () => {
    if (productFNSku && printQty) {
      await print({
        apiUrl: 'product-warning-label3x2',
        data: {
          productFNSku,
          productSku,
          productName,
          productCondition,
          expirationDate: productExpiration == null ? '' : moment(productExpiration).format('MM-DD-YYYY'),
          printQty: printQty,
          batchID: batchID
        }
      });
    } else toast.warn('Missing inputs');
  };
  const printWarningLabel2x1 = async () => {
    if (productFNSku && printQty) {
      await print({
        apiUrl: 'product-warning-label2x1',
        data: {
          productFNSku,
          productSku,
          productName,
          productCondition,
          expirationDate: productExpiration == null ? '' : moment(productExpiration).format('MM-DD-YYYY'),
          printQty: printQty,
          batchID: batchID
        }
      });
    } else toast.warn('Missing inputs');
  };
  const printMFProductLabel = async () => {
    if (productFNSku && printQty) {
      await print({
        apiUrl: 'product-mf-label2x1',
        data: {
          productFNSku,
          productSku,
          productName,
          productCondition,
          expirationDate: productExpiration == null ? '' : moment(productExpiration).format('L'),
          printQty: printQty,
          batchID: batchID
        }
      });
    } else toast.warn('Missing inputs');
  };

  return (
    <div className="flex flex-col w-full">
      <PageHeader headingText="FNSKU/Product Labels" />
      <PrintCardsContainer
        leftCard={
          <Card headerText="Product Information">
            <div className="flex flex-wrap">
              <div className="flex flex-col w-3/5 gap-3 mt-3">
                <SInput name="SKU" value={productSku} onChange={setProductSku} />
                <SInput name="FNSKU" value={productFNSku} onChange={setProductFNSku} />
                <div className="w-full">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    Expiration Date
                  </label>
                  <DatePicker
                    className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    selected={productExpiration}
                    onChange={(date: Date) => setProductExpiration(date)}
                  />
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-center w-2/5">
                <div className="flex flex-col px-3 mt-5">
                  <h6 className="flex font-bold text dark:text-white">{productFNSku}</h6>
                  <h6 className="flex text dark:text-white">{productName}</h6>
                  <div className="flex items-center justify-center w-full mt-2 border rounded max-h-96 dark:bg-gray-700">
                    {productImage ? (
                      <img alt="product" src={productImage} className="w-auto h-auto max-h-96" />
                    ) : (
                      <svg
                        className="w-full h-48 p-5 text-gray-200"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 640 512"
                      >
                        <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Card>
        }
        rightCard={
          <Card headerText="Print">
            <div className="flex flex-wrap gap-5">
              <button
                disabled={!canGenerate}
                onClick={printWarningLabel3x2}
                className="w-full base-green-button"
              >
                Poly Bag W/ Suff Warning (3x2)
              </button>
              <button
                disabled={!canGenerate}
                onClick={printWarningLabel2x1}
                className="w-full base-green-button"
              >
                All Products W/O Suff Warning (2-¼” x 1-¼”)
              </button>
              <button
                disabled={!canGenerate}
                onClick={printMFProductLabel}
                className="w-full base-gray-button"
              >
                MF Product Label (3x2)
              </button>
              <button
                disabled={!canGenerate}
                onClick={resetAll}
                className="w-full base-yellow-button"
              >
                Clear All
              </button>
            </div>
          </Card>
        }
      />
      <Card headerText="Select QTY to print">
        <QTYButtons printQty={printQty} setPrintQty={setPrintQty} />
      </Card>
      <PDFDialog isOpen={isPDFDialogOpen} setIsOpen={setIsPDFDialogOpen} pdf={pdfBase64} />
    </div>
  );
}

export default FnSkuLabelPage;
